'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GooglePlayIcon = exports.AppStoreIcon = exports.NativeAppIcon = exports.ClockIcon = exports.BgEmailIcon = exports.EmailIcon = exports.BgLocationIcon = exports.LocationIcon = exports.BgPhoneIcon = exports.PhoneIcon = exports.ShoppingBagIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function (_Component) {
    (0, _inherits3.default)(Icon, _Component);

    function Icon() {
        (0, _classCallCheck3.default)(this, Icon);
        return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, _getPrototypeOf2.default)(Icon)).apply(this, arguments));
    }

    (0, _createClass3.default)(Icon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                _lodash2.default.omit(this.props, 'url'),
                _react2.default.createElement('img', { src: this.props.url,
                    style: {
                        width: this.props.width,
                        height: this.props.height
                    }
                })
            );
        }
    }]);
    return Icon;
}(_react.Component);

Icon.propTypes = {
    url: _propTypes2.default.string,
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
};

var BgIcon = function (_Component2) {
    (0, _inherits3.default)(BgIcon, _Component2);

    function BgIcon() {
        (0, _classCallCheck3.default)(this, BgIcon);
        return (0, _possibleConstructorReturn3.default)(this, (BgIcon.__proto__ || (0, _getPrototypeOf2.default)(BgIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(BgIcon, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { style: {
                    background: 'url(' + this.props.url + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 50%',
                    width: this.props.boundingWidth,
                    height: this.props.boundingHeight
                } });
        }
    }]);
    return BgIcon;
}(_react.Component);

BgIcon.propTypes = {
    url: _propTypes2.default.string,
    boundingWidth: _propTypes2.default.number,
    boundingHeight: _propTypes2.default.number
};

BgIcon.defaultProps = {
    boundingWidth: 18,
    boundingHeight: 18
};

var ShoppingBagIcon = exports.ShoppingBagIcon = function ShoppingBagIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/shoppingbag2.png',
        width: 43, height: 50
    }, props));
};

var PhoneIcon = exports.PhoneIcon = function PhoneIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/phone-icon-light.png'
    }, props));
};

var BgPhoneIcon = exports.BgPhoneIcon = function BgPhoneIcon(props) {
    return _react2.default.createElement(BgIcon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/phone-icon-light.png'
    }, props));
};

var LocationIcon = exports.LocationIcon = function LocationIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/location-icon-light.png',
        width: 12, height: 16
    }, props));
};

var BgLocationIcon = exports.BgLocationIcon = function BgLocationIcon(props) {
    return _react2.default.createElement(BgIcon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/location-icon-light.png'
    }, props));
};

var EmailIcon = exports.EmailIcon = function EmailIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/email-icon-light.png'
    }, props));
};

var BgEmailIcon = exports.BgEmailIcon = function BgEmailIcon(props) {
    return _react2.default.createElement(BgIcon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/email-icon-light.png'
    }, props));
};

var ClockIcon = exports.ClockIcon = function ClockIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'https://storage.googleapis.com/openrest-static/emails_res/clock.png',
        width: 16, height: 16
    }, props));
};

var NativeAppIcon = exports.NativeAppIcon = function NativeAppIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'http://storage.googleapis.com/openrest-static/build/getAppIcon@2x.png.644d9835f3dd8d76d7fa054ee5439170.png',
        width: 84, height: 95
    }, props));
};

var AppStoreIcon = exports.AppStoreIcon = function AppStoreIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'http://storage.googleapis.com/openrest-static/build/getAppIOS@2x.png.559b5ce664184685a4542dfce42f991f.png',
        width: 141, height: 42
    }, props));
};

var GooglePlayIcon = exports.GooglePlayIcon = function GooglePlayIcon(props) {
    return _react2.default.createElement(Icon, (0, _extends3.default)({
        url: 'http://storage.googleapis.com/openrest-static/build/getAppAndroid@2x.png.7e02f01ec71c5b97051c1c1237cdc769.png',
        width: 141, height: 42
    }, props));
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/EmailIcons.js
// module id = 272
// module chunks = 0